<div class="dialog-content-wrapper" >
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>

    </mat-toolbar>

    <div mat-dialog-content class="p-8 pb-0 m-0"  fusePerfectScrollbar>
<!--    <div mat-dialog-content class="pb-0 m-0"  fusePerfectScrollbar>-->

        <form [formGroup]="entityForm" >
            <!-- <mat-form-field dense appearance="outline" floatLabel="always" class="w-100-p"> -->
            <mat-form-field dense appearance="outline" class="w-100-p">
                <mat-label>Nombre</mat-label>
                <input matInput placeholder="Nombre" name="name" formControlName="name"
                       required>
            </mat-form-field>

            <!-- Tipo de proyecto -->
            <mat-form-field *ngIf="type === 'GeneralTask'" dense appearance="outline" floatLabel="always" class="w-100-p">
                <mat-label>Tipo</mat-label>
                <mat-select name="type" [compareWith]="_systemService.compareFunction"
                            formControlName="type" [value]="entity.type" required>
                    <mat-option *ngFor="let type of _projectTreeService.taskTypes" [value]="type">
                        {{type.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Tipo de proyecto -->
            <mat-form-field *ngIf="type === 'Phase'" dense appearance="outline" floatLabel="always" class="w-100-p">
                <mat-label>Tipo</mat-label>
                <mat-select name="type" [compareWith]="_systemService.compareFunction"
                            formControlName="type" [value]="entity.type" required>
                    <mat-option *ngFor="let type of _projectTreeService.phaseTypes" [value]="type">
                        {{type.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </form>
    </div>
    <div mat-dialog-actions class="accent m-0 p-4" fxLayout="row" fxLayoutAlign="end center">

        <button mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel"
                matTooltip="Cancelar">
            Cancelar
        </button>

        <button mat-button
                class="accent save-button"
                (click)="matDialogRef.close(entityForm)"
                [disabled]="entityForm.invalid"
                aria-label="SAVE">
            Guardar
        </button>

    </div>
</div>




